import React from "react";
import CryptoJS from "crypto-js";
import moment from 'moment';
import 'moment/locale/es';
import Swal from 'sweetalert2'
import secureLocalStorage from "react-secure-storage";
import { VALIDATION_MESSAGE } from "../constants/Constants";
import { StorageConstant } from "../constants/Constants";
import { Config } from "../config/Config";
import { invalidatePendingDashboardBootstrapCache } from "./pendingDashboardBootstrapState";
import { formatAddressListRow } from "../component/myquotation/view-quotation/helpers";
import TopImage from '../Assets/images/listing-bnr.webp'
import axios from "axios";


// import * as momentTZ from 'moment';


// import dateFormat from 'dateformat';
// ====Start encode & decode=====
const secretKey4 = 'O@RcQfTjWnZr4-PaiOwnER-KaNdRgUkX';
const secretKey5 = 'O@RcQChillINg-PaiOwnER-KaNdRgUkX';
const DefaultUser = require('../Assets/images/user.png')


export const encodeID = (id: any) => {
  if (id != null) {
    const encryptedData4 = CryptoJS.AES.encrypt(id.toString(), secretKey4).toString();
    const encryptedDataMain: any = CryptoJS.AES.encrypt(encryptedData4.toString(), secretKey5).toString();
    return encryptedDataMain?.replaceAll("/", "Pai");
  } else {
    return id;
  }
}
export const decodeID = (id: any) => {
  if (id == null || id === '') {
    return id;
  }
  try {
    const replaceddata: any = id?.replaceAll("Pai", "/");
    const decryptedData = CryptoJS.AES.decrypt(replaceddata.toString(), secretKey5).toString(CryptoJS.enc.Utf8);
    const decryptedData1 = CryptoJS.AES.decrypt(decryptedData.toString(), secretKey4).toString(CryptoJS.enc.Utf8);
    return decryptedData1;
  } catch {
    /** Corrupt ciphertext, wrong key, plain-text legacy value, or partial write — avoid crashing (e.g. signup validation calling getFromStorage for Translate on every keystroke). */
    return id;
  }
}

export const saveToStorage = ({ key, value, type = 'local', isSecure = true }: {
  key: string,
  value: any,
  type?: string,
  isSecure?: boolean
}) => {
  let newValue = JSON.stringify(value);
  if (isSecure) {
    newValue = encodeID(newValue);
  }
  if (typeof window !== 'undefined') {
    if (type === 'local') {
      localStorage.setItem(key, newValue);
    } else if (type === 'session') {
      sessionStorage.setItem(key, newValue);
    }
  }
};

export const getFromStorage = ({ key, type = 'local', isSecure = true }: {
  key: string,
  type?: string,
  isSecure?: boolean,
}) => {
  let value: any = null;
  if (typeof window !== 'undefined') {
    if (type === 'local') {
      value = localStorage.getItem(key)
    } else if (type === 'session') {
      value = sessionStorage.getItem(key)
    }
  }
  if (isSecure && value != null && value !== '') {
    value = decodeID(value);
  }
  if (value == null || value === '') {
    return value;
  }
  return isJson(value) ? JSON.parse(value) : value;
};

export const deleteFromStorage = ({ key, type = 'local' }: {
  key: string,
  type?: string
}) => {
  if (typeof window !== 'undefined') {
    if (type === 'local') {
      if (key) {
        localStorage.removeItem(key)
      } else {
        localStorage.clear()
      }
    } else if (type === 'session') {
      if (key) {
        localStorage.removeItem(key)
      } else {
        localStorage.clear()
      }
    }
  }
};


// ====End encode & decode=====

export function isJson(str: any) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

// ===Start Select handlechange===
export const handleMultiSelectChange = (selectVal: any) => {
  const selectedValues = selectVal?.e ? selectVal?.e.map((d: any) => d.value) : [];
  selectVal?.setValueFunc(selectVal?.errorsKey, selectedValues);
  selectVal?.setSelectedFunc(selectVal?.e);
};
// ===End Select handlechange===

// ===Start Cache storage===
export const setCache = async (key: string, value: any) => {
  const data = new Response(JSON.stringify(value));
  if ("caches" in window) {
    const cache = await caches.open(key);
    cache.put(key, data);
  }
};

export const setDateFormat = (date: any) => {
  let formatDate = '';
  // if (date) {
  //   formatDate = moment(date).format('YYYY-MM-DD')
  // }
  if (date && moment(date, 'YYYY-MM-DD', true).isValid()) {
    formatDate = moment(date).format('YYYY-MM-DD');
  }
  return formatDate;
}

export const getDateFormat = (date: any) => {
  let formatDate = '';
  // if (date) {
  //   formatDate = moment(date).format('YYYY-MM-DD')
  // }
  // if (date && moment(date, 'YYYY-MM-DD', true).isValid()) {
  if (date && moment(date).isValid()) {
    formatDate = moment(date).format('YYYY-MM-DD');
  }
  return formatDate;
}

export const getDateFormatData = (date: any) => {
  let formatDate;
  formatDate = moment(date).format('MM/DD/YYYY')
  // formatDate = moment(date).toDate();
  return formatDate;
}


export const handleShowSwalConfirmation = (msg: any = null, showCancel = false, showTitle = true) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: showTitle ? VALIDATION_MESSAGE?.ARE_YOU_SURE : "",
      text: msg ? msg : "Please complete all steps to proceed.",
      icon: 'warning',
      showDenyButton: showCancel,
      confirmButtonColor: '#31CE36',
      confirmButtonText: showCancel ? 'Yes' : 'Ok',
      allowOutsideClick: false,
      // closeable: true
    }).then((result) => {
      resolve(result.isConfirmed);
    });
  });

}


export const handleShowSwalConfirmationOk = (msg: any = null, showCancel = false) => {


  return new Promise((resolve) => {
    Swal.fire({
      title: showCancel ? VALIDATION_MESSAGE?.ARE_YOU_SURE : "",
      text: msg ? msg : "Please complete all steps to proceed.",
      icon: 'warning',
      showDenyButton: showCancel,
      // showCancelButton: showCancel,
      confirmButtonColor: '#31CE36',
      cancelButtonColor: '#d33',
      denyButtonText: 'No',
      confirmButtonText: 'Yes',
      allowOutsideClick: false,

    }).then((result) => {
      resolve(result.isConfirmed);
    });


  });

}


export const handleShowSwalConfirmationCancel = (msg: any = null, showCancel = false, showTitle = true) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: showTitle ? VALIDATION_MESSAGE?.ARE_YOU_SURE : "",
      text: msg ? msg : "Please complete all steps to proceed.",
      icon: 'warning',
      showDenyButton: showCancel,
      confirmButtonColor: '#31CE36',
      confirmButtonText: showCancel ? 'Ok' : 'Ok',
      allowOutsideClick: false,
      denyButtonText: 'Cancel',
    }).then((result) => {
      resolve(result.isConfirmed);
    });
  });

}

export const getCache = async (key: string, setData: any) => {
  if (typeof caches === "undefined") return false;
  const cacheStorage = await caches.open(key);
  const cachedResponse = await cacheStorage.match(key);
  if (!cachedResponse || !cachedResponse.ok) {
    setData("Fetch failed!");
    return null;
  }
  return cachedResponse.json().then((item: any) => {
    setData(item);
  });
};
// ===End Cache storage===

// ===Start Image Icon Show=== 
export const ImageUrl = (icon: any) => {
  return icon
}
// ===End Image Icon Show=== 

// Form data using image upload
export const renderFormData = (values: any) => {
  var formData = new FormData();
  Object.keys(values).map(function (key) {
    formData.append(key, values[key])
  });
  return formData
}

// Default image use if no image 
export const userPicUrl = (url: any) => {
  const PUrl = url ? url : DefaultUser;
  return PUrl;
}

// Default banner image 

export const bannerPicUrl = (url: any) => {
  const PUrl = url ? url : TopImage;
  return PUrl;
}
// Name and Last name show
export const FullName = (fname: any, lname: any) => {
  let HFname = fname ? fname : '';
  let HLname = lname ? lname : '';
  return HFname + " " + HLname
}

// Country code  + Number
export const FullPhoneNUmber = (phone_country_code: any, phone_number: any) => {
  let Hpcc = phone_country_code ? '+' + phone_country_code + ' ' : '';
  let Hpn = phone_number ? phone_number : '';
  return Hpcc + Hpn
}

// Last Url location 
export const getLastURL = (location: any) => {
  let lastURL = location && location.pathname && location.pathname.split('/') && location.pathname.split('/').pop();
  return lastURL;
}

export const getDate = (date = null) => {
  const formattedDate = date ? moment(new Date(date)).format('MM/DD/YY') : '';
  return formattedDate;
}
export const getDateTime = (date: string) => {
  const formattedDate = date ? moment(new Date(date)).format('MM/DD/YY  ') : '';
  return formattedDate;
}

export const getPriceHelper = (price: any) => {
  if (price) {
    const priceString = typeof price === 'number' ? price.toFixed(2) : price != undefined ? price.toString() : '';
    const parts = priceString.split('.');
    if (parts?.length === 1) {
      return `${parts[0]}`;
    }
    const integerPart = parts[0];
    const decimalPart = parts[1].slice(0, 2)
    let lastPrice = `${integerPart}.${decimalPart}`;
    
    return lastPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return '0.00'
  }
};




//  date utc  formate
// export const getUtcDateTime = (date: string) => {
//   const formattedDate = moment((date)).utc().format('DD, MMMM, YYYY H:mm');
//   return formattedDate;
// }





export const formatDate = (isoDate: any) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  // return `${year}-${month}-${day}`;
  return `${month}-${day}-${year}`;
}


export const formatMonth = (isoDate: any) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');

  return `${month}-${day}-${year}`;
}


// export const setItemToStorage = (key: any, value: any) => {
//   secureLocalStorage.setItem(key, JSON.stringify((value)));
// }

// export const getItemFromStorage = (key: any) => {
//   const val: any = secureLocalStorage.getItem(key);
//   return isJson(val)? JSON.parse(val):"";
// }

// export const removeItemFromStorage = (key: any) => {
//   return secureLocalStorage.removeItem(key);
// }

// export const clearStorage = () => {
//   secureLocalStorage.clear();
// }

export const getObjectKeyByValue = (object: any, value: any) => {
  return Object.keys(object).filter(key =>
    object[key] === value);
}

export const getSearchQueryParams = (location: any, key: any) => {
  const searchParams = new URLSearchParams(location.search);
  const value = searchParams.get(key);
  return value;
}


export const getCurrentDate = () => {
  // const today = new Date();
  // const year = today.getFullYear();
  // const month = String(today.getMonth() + 1).padStart(2, '0');
  // const day = String(today.getDate()).padStart(2, '0');

  // return `${year}-${month}-${day}`;
  // return moment()
  return moment().format('YYYY-MM-DD');
}

export const getMoneyHelper = (amount: any) => {
  return `${amount ? '$' + amount : ""}`
}
// country code dropdown

export const DefaultEditorButtons = [
  // 'source', '|',
  'bold',
  // 'strikethrough',
  'underline',
  'italic', '|',
  'ul',
  'ol', '|',
  'outdent', 'indent', '|',
  'font',
  'fontsize',
  // 'brush',
  // 'paragraph', '|',
  // 'table',
  // 'link', '|',
  'align', 'undo', 'redo', '|',
  'hr',
  // 'eraser',
  // 'copyformat', '|',
  // 'symbol',
  'fullsize',
  // 'print',
  // 'paste'
]



export const replaceToString = (str: any) => {
  if (str === null || str === '') {
    return false;
  } else {
    str = str.toString();
    const replacedString = str.replace(/<[^>]+>|&nbsp;/g, "");

    return replacedString;
  }
};

export const imageExtentionSupport = ["jpeg", "jpg", "png", "webp", "PNG", "JPG", "JPEG", "WEBP"];
export const videoExtentionSupport = ["mp4", "avi", "mkv", "MP4"];
export const ImageVideoExtentionSupport = ["jpeg", "jpg", "png", "webp", "PNG", "JPG", "JPEG", "WEBP", "mp4", "avi", "mkv", "MP4"]


export const getYear = () => {
  const minDate = new Date(2023, 0, 2).toISOString().split('T')[0];
  return minDate;
}

export const calculateMinAfterDate = (date: any) => {

  if (!date) {
    return '';
  } else {
    const result = new Date(date);
    result.setDate(result.getDate() + 1);

    // Check if the date is invalid
    if (isNaN(result.getTime())) {
      return ''; // or handle this case as needed in your application
    }

    return result.toISOString().split('T')[0];
  }
};






export const manualValidateForm = async ({ formSchema, errors, getValues, setError }: any) => {
  return new Promise((resolve, reject) => {
    formSchema.validate(getValues(), { abortEarly: false })
      .then(() => {
        Object.keys(errors).forEach((field) => {
          setError(field, {
            type: 'manual',
            message: '',
          });
        });
        resolve(true);
      })
      .catch((error: any) => {
        error.inner.forEach((err: any) => {
          setError(err.path, {
            type: 'manual',
            message: err.message,
          });
        });
        Object.keys(getValues()).forEach((field) => {
          if (!error.inner.find((err: any) => err.path === field)) {
            setError(field, {
              type: 'manual',
              message: '',
            });
          }
        });
        resolve(false);
      });
  });
};

export const mergeDateTime = (dateString: any, timeString: any) => {
  var mergedDateTimeString = dateString + " " + timeString;

  return mergedDateTimeString;
}


export const formatDateTime = (dateString: any) => {
  // Parse the original date string using Moment.js and specify UTC time zone
  const parsedDate = moment.utc(dateString);

  // Format the date as "YYYY-MM-DD" (2024-12-10)
  const formattedDate = parsedDate.format("YYYY-MM-DD");

  // Format the time as "HH:mm" (16:12) in local time zone
  const formattedTime = parsedDate.format("HH:mm");

  return { formattedTime, formattedDate };

}

export const addDay = (date: any, days: any) => {
  var result = new Date(date);
  let formatDate;
  let newData = result.setDate(result.getDate() + days);
  formatDate = moment(newData).format('YYYY-MM-DD')
  return formatDate;

  return result;
}


export const addDays = (date: any, days: any) => {
  var result = new Date(date);
  let formatDate;
  result.setDate(result.getDate() + days);

  return result;
}

export const StringSplitHelper = (text: any, limit: any = 15) => {
  let shortenedText = ""
  if (text) {
    shortenedText = `${text.substring(0, limit)}${text?.length > limit ? '...' : ""}`;
  }
  return shortenedText;
}
export const isEmpty = (value: any) => {
  return Boolean(value)
}


export const formatOrderDateTimeRange = (date: string, start: string, end: string, timezone: string): string => {

  const formattedDate = moment(date).format('DD/MM/YY');
  const startTime = moment.utc(start, 'HH:mm:ss').format('h A');
  const endTime = moment.utc(end, 'HH:mm:ss').format('h A');

  return `${formattedDate} | ${startTime} - ${endTime}`;

};

export const renderFormDataMultiple = (values: any, images: any[]) => {
  var formData = new FormData();
  Object.keys(values).forEach(function (key) {
    if (key === "image_file") {
      images.forEach((image, index) => {
        formData.append(`image_file`, image);
      });
    } else {
      formData.append(key, values[key]);
    }
  });
  return formData;
};


export const getLocalTime = (time: any,) => {
  const localDate = moment.utc(time).local().format('YYYY-MM-DD HH:mm:ss');
  const localTime = moment.utc(time).local().format('h:mm A');
  return { localTime, localDate };
};


//dev sd


export const getDateTimeFormat = (dTime: any, format: any = 24) => {
  let formatDateTime = '';
  let momentFormat = 'YYYY-MM-DD';
  if (dTime) {
    if (format === 12) {
      momentFormat += ' hh:mm A';
    } else if (format === 24) {
      momentFormat += ' HH:mm';
    }
    formatDateTime = moment((dTime)).utc().format(momentFormat)
  }
  return formatDateTime;
};



export const WeekDayFormat = (data: any) => {
  if (data != undefined) {

    const daysArray = JSON.parse(data);
    const weekdayOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const sortByWeekday = (a: any, b: any) => {
      return weekdayOrder.indexOf(a.day) - weekdayOrder.indexOf(b.day);
    };
    daysArray.sort(sortByWeekday);
    return daysArray.map((dayData: any) => ({
      day: dayData.day,
      start_time: moment.utc(dayData.start_time, "HH:mm:ss").local().format("HH:mm:ss"),
      end_time: moment.utc(dayData.end_time, "HH:mm:ss").local().format("HH:mm:ss")

    }));
  } else {
    return []
  }
};





// get Browser Timezone
export const getBrowserTimezone = (): string => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone;
};

// convert To USA Time
export const convertToBrowserTime = (date: string): string => {
  const timeZone = getBrowserTimezone();
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone,
  };

  // Parse the input date
  const parsedDate = new Date(date);

  // Subtract 5 hours (5 * 60 * 60 * 1000 milliseconds)
  const adjustedDate = new Date(parsedDate.getTime() - 5 * 60 * 60 * 1000);

  // Format the adjusted date
  return new Intl.DateTimeFormat('en-US', options).format(adjustedDate);
};


export const isAuthenticated = () => {
  const token = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN });
  if (token) {
    return token
  } return false
}

export const getUserId = () => {
  const data = getFromStorage({ key:'user_data' });
  if (data) {
    return data?.data?.id
  } return false
}

export const changeLanguage = () => {
  const Translate = getFromStorage({ key: StorageConstant?.Translate });
  if (Translate) {
    return Translate
  } return false
}
 
export const handleLogout = () => {
  invalidatePendingDashboardBootstrapCache();
  window.location.href = `${Config?.BASE_URL}/login`;
  localStorage.clear()

}
export const capitalizeFirstLetter = (str: string) => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  else {
    return ""
  }
}

// backspace enter
export const handleBackspaceAndEnter = (e: any, index: any, otpBoxRef: any, numberOfDigits: any) => {
  if (e.key === "Backspace" && !e.target.value && index > 0) {
    return otpBoxRef.current[index - 1].focus();
  }
  if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
    return otpBoxRef.current[index + 1].focus();
  }
}


/** Moment locale key from app language (`Translate` in storage). */
export const getAppMomentLocale = (): string => {
  const translate =
    getFromStorage({ key: StorageConstant?.Translate }) ??
    (typeof window !== 'undefined' ? window.localStorage?.getItem('Translate') : null);
  return String(translate || '').toLowerCase() === 'spa' ? 'es' : 'en';
};

/** Keep moment's global locale aligned with app language (importing `moment/locale/es` defaults to `es`). */
export const syncMomentLocaleFromAppLanguage = (): void => {
  moment.locale(getAppMomentLocale());
};

/** Long month date (e.g. May 21, 2026); locale follows app language (`Translate` storage). */
export const formatDisplayLongDate = (date: any, fallback = '—') => {
  if (date == null || date === '') return fallback;
  const m = moment(date).clone().locale(getAppMomentLocale());
  return m.isValid() ? m.format('MMMM D, YYYY') : fallback;
};

/** Parse API/DB datetimes consistently for relative-time display. */
export function parseApiDateTime(input: unknown): moment.Moment | null {
  if (input == null || input === '') return null;
  if (input instanceof Date) {
    const parsed = moment(input);
    return parsed.isValid() ? parsed : null;
  }
  const raw = String(input).trim();
  if (!raw) return null;
  if (/[zZ]$/.test(raw) || /[+-]\d{2}:?\d{2}$/.test(raw)) {
    const parsed = moment(raw);
    return parsed.isValid() ? parsed : null;
  }
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(raw)) {
    const parsed = moment.utc(raw, 'YYYY-MM-DD HH:mm:ss');
    return parsed.isValid() ? parsed : null;
  }
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(raw)) {
    const parsed = moment.utc(raw);
    return parsed.isValid() ? parsed : null;
  }
  const parsed = moment(raw);
  return parsed.isValid() ? parsed : null;
}

/** Relative time; locale follows app language (`Translate` storage), not Moment’s global default. */
export const timeAgo = (date: any) => {
  const parsed = parseApiDateTime(date);
  if (!parsed) return '';
  return parsed.clone().locale(getAppMomentLocale()).fromNow();
};


/** USD→EUR when no `eurCurrencyValue` in localStorage (encoded like `currencyValue`). */
const DEFAULT_USD_TO_EUR = 0.92;

export const getUsdToEurRate = (): number => {
  try {
    const raw = localStorage.getItem("eurCurrencyValue");
    if (raw) {
      const v = Number(decodeID(raw));
      if (Number.isFinite(v) && v > 0) return v;
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_USD_TO_EUR;
};

export const CurrencyConvert = (price: any, type: any) => {
  if (type == "PHP") {
    if (price > 0) {
      const getPrice = localStorage.getItem('currencyValue')
      const priceValue = decodeID(getPrice)
      let value = Number(priceValue) * Number(price)
      return `€${value}`
    } else {
      return `€ 0.00`
    }
  }
  if (type == "EUR") {
    const n = Number(price);
    if (n > 0) {
      return `€${(n * getUsdToEurRate()).toFixed(2)}`;
    }
    return "€ 0.00";
  }
  return `$${price ? Number(price)?.toFixed(2) : '0.00'}`
};


export const CurrencyConvertHistory = (price: any, type: any) => {
  if (type == "PHP") {
    if (price > 0) {
      const getPrice = localStorage.getItem('currencyValue')
      const priceValue = decodeID(getPrice)
      let value = Number(priceValue) * Number(price)
      return Number(value)
    } else {
      return `0.00`
    }
  }
  if (type == "EUR") {
    const n = Number(price);
    if (Number.isFinite(n) && n > 0) {
      return Number((n * getUsdToEurRate()).toFixed(2));
    }
    return "0.00";
  }
  return price ? Number(price) : '0.00'
};


export const CurrencyIcon = (type: any) => {
  if (type == "PHP" || type == "EUR") {
    return '€'
  }
  return  '$'
};


export const GetPrices = (data: any) => {

  const productamount = data?.quotes_detail?.reduce((accumulator: any, item: any) => {
    const perProductPrice = parseFloat(item?.per_product_price ? item?.per_product_price : 0);  // Convert string to number
    const quantity = item?.new_quantity ? item?.new_quantity : item?.quantity;  // Assuming quantity is a number
    const totalAmount = perProductPrice * quantity;  // Calculate total amount for each item
    return accumulator + totalAmount;  // Add totalAmount to the accumulator
  }, 0);

  const shippingamount = data?.quotes_detail?.reduce((accumulator: any, item: any) => {
    const perProductPrice = parseFloat(item?.per_piece_shipping_price ? item?.per_piece_shipping_price : 0);  // Convert string to number
    const perProductW_V = parseFloat(item?.per_piece_w_v ? item?.per_piece_w_v : 0);  // Convert string to number
    const quantity = item?.new_quantity ? item?.new_quantity : item?.quantity;  // Assuming quantity is a number
    const totalAmount = perProductPrice * quantity * perProductW_V;  // Calculate total amount for each item
    return accumulator + totalAmount;  // Add totalAmount to the accumulator
  }, 0);


  var total_tax = '0'
  if (data?.tax_amount) {
    const total = Number(shippingamount) + Number(productamount) + Number(data?.other_charges)
    const taxValue = (total * data?.tax_amount) / 100;
    total_tax = `${taxValue.toFixed(2)}`;
  }

  const totalAmount = Number(productamount) + Number(shippingamount) + Number(data?.other_charges) + Number(total_tax)

  return { productamount, shippingamount, totalAmount, total_tax }


}


export const GethistoryPrices = (data: any) => {

  const NEWDATA = data?.filter((res: any) => res?.is_deleted == "0");


  const productamount = NEWDATA?.reduce((accumulator: any, item: any) => {
    const perProductPrice = parseFloat(item?.per_product_price ? item?.per_product_price : 0);  // Convert string to number
    const quantity = item?.new_quantity ? item?.new_quantity : item?.quantity;  // Assuming quantity is a number
    const totalAmount = perProductPrice * quantity;  // Calculate total amount for each item
    return accumulator + totalAmount;  // Add totalAmount to the accumulator
  }, 0);

  const shippingamount = NEWDATA?.reduce((accumulator: any, item: any) => {
    const perProductPrice = parseFloat(item?.per_product_shipping_price ? item?.per_product_shipping_price : 0);  // Convert string to number
    const perProductW_V = parseFloat(item?.per_piece_w_v ? item?.per_piece_w_v : 0);  // Convert string to number
    const quantity = item?.new_quantity ? item?.new_quantity : item?.quantity;  // Assuming quantity is a number
    const totalAmount = perProductPrice * quantity * perProductW_V;  // Calculate total amount for each item
    return accumulator + totalAmount;  // Add totalAmount to the accumulator
  }, 0);

  const Othercharges = NEWDATA?.map((res: any) => {
    if (res?.other_charges) {
      return (res?.other_charges)
    }
  });

  const other_charges_amount = Othercharges[0] > 0 ? Othercharges[0] : '0'

  const taxamount = NEWDATA?.map((res: any) => {
    if (res) {
      return (res?.total_tax)
    }
  });

  var total_tax = '0'
  if (taxamount[0] > 0) {
    const total = Number(shippingamount) + Number(productamount) + Number(other_charges_amount)
    const taxValue = (total * taxamount[0]) / 100;
    total_tax = `${taxValue.toFixed(2)}`;
  }
  const totalAmount = Number(productamount) + Number(shippingamount) + Number(other_charges_amount) + Number(total_tax)

  return { productamount, shippingamount, totalAmount, total_tax }


}


export const getBrowserType = (userAgent: any) => {
  const browserRegex = /(Firefox|Chrome)\/([\d.]+)/;
  const osRegex = /\(([^)]+)\)/;

  const browserMatch = userAgent.match(browserRegex);
  const osMatch = userAgent.match(osRegex);

  let browser = '';
  let version = '';
  let os = '';
  let platform = '';

  if (browserMatch) {
    browser = browserMatch[1];
    version = browserMatch[2];
  }

  if (osMatch) {
    os = osMatch[1];

    if (os.includes('Linux')) {
      platform = 'Linux';
    } else if (os.includes('Windows')) {
      platform = 'Windows';
    } else if (os.includes('Macintosh') || os.includes('Mac OS X')) {
      platform = 'Mac';
    } else {
      platform = 'Unknown';
    }
  }

  return { browser, version, os, platform };
}

export const getAverageRating = (details: any) => {
    if (!details) {
      return 0;
    }
 
    const shopping = parseFloat(details?.shopping_experience ?? '0');
    const payment = parseFloat(details?.payment_experience ?? '0');
    const product = parseFloat(details?.product_received_corresponds ?? '0');
 
    const values = [shopping, payment, product].filter(
      v => !isNaN(v as number),
    ) as number[];
 
    if (!values.length) {
      return 0;
    }
 
    const sum = values.reduce((acc, v) => acc + v, 0);
    return sum / values.length;
  };

/** Quote detail header: denormalized quotation address fields are often null; prefer joined `address_detail` (API `/quotes/detail`). Street line only — no Address line 2; no repeated city/state/zip. */
export const formatQuotationDeliveryAddress = (row: any): string => {
  if (!row || typeof row !== "object") return "—";
  const a = row.address_detail;
  return formatAddressListRow(
    a
      ? {
          ...a,
          street_line: row.street_line ?? a.street_line,
          zip_code: row.zip_code ?? a.zip_code,
        }
      : {
          street_line: row.street_line,
          city: row.city,
          state: row.state,
          zip_code: row.zip_code,
          country: row.country,
        },
  );
};
 